import React from 'react'
import { injectIntl, FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Game } from '../../Core'

import * as tutorialSelectors from '../tutorial.selectors'

import SettingsMenuButton from '../../Mars/Settings/SettingsMenuButton'

const VeredictTutorialScreen = ({ confidentialNumber, addPopup }) => (
  <main className="main" role="main">
    <SettingsMenuButton />
    <div className="container background--mina__canvas">
      <div className="content">
        <div className="tutorial--welcome">
          <h1 className="h1">
            <span className="name">
              <FormattedMessage
                id="tutorial.turn5.academy_text2.p1"
                values={{ confidentialNumber }}
              />
            </span>
          </h1>
          <p>
            <b>
              <FormattedMessage id="tutorial.turn5.academy_text2.p2" />
            </b>
          </p>
          <p>
            <FormattedMessage id="tutorial.turn5.academy_text2.p3" />
          </p>
          <p>
            <FormattedMessage id="tutorial.turn5.academy_text2.p4" />
          </p>
          <div
            className="btn--orange"
            onClick={() => {
              addPopup('tutorial_end')
            }}
          >
            <span className="icon-rocket"></span>
            <span>
              <FormattedMessage id="tutorial.turn5.academy_text2.go_mars" />
            </span>
          </div>
        </div>
      </div>
    </div>
  </main>
)

VeredictTutorialScreen.propTypes = {
  addPopup: PropTypes.func,
  confidentialNumber: PropTypes.number,
}

const mapDispatchToProps = (dispatch) => ({
  addPopup: bindActionCreators(Game.actions.addPopup, dispatch),
})

const mapStateToProps = (state) => ({
  confidentialNumber: tutorialSelectors.getConfidentialNumber(state),
})

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(VeredictTutorialScreen))
